import { safeArray } from "@/helpers/functions/ArrayHelpers";

export const COLLECTION_BY_LEVEL = Object.freeze({
  regiao: "regioes",
  estado: "estados",
  municipio: "municipios",
});

export const VALUE_KEY_BY_LEVEL = Object.freeze({
  regiao: "regiao",
  estado: "sigla",
  municipio: "value",
});

export function emptyModelValue() {
  return {
    regioes: [],
    estados: [],
    municipios: [],
  };
}

export function normalizeModelValue(value) {
  const isIdentifier = (item) =>
    typeof item === "string" || typeof item === "number";

  return {
    regioes: safeArray(value?.regioes).filter(isIdentifier).map(String),
    estados: safeArray(value?.estados).filter(isIdentifier).map(String),
    municipios: safeArray(value?.municipios).filter(isIdentifier),
  };
}
